module.exports = __webpack_public_path__ + "static/media/BITN.eae9c2e1.svg";